export type CommunityTrendingInputs = {
  joins7d: number;
  wau: number;
  memberCount: number;
  activity7d: number;
};

export function computeCommunityTrendingScore(input: CommunityTrendingInputs): number {
  const joinsScore = input.joins7d * 10;
  const activityScore = input.activity7d * 2;
  const wauScore = input.wau * 3;
  const memberScore = Math.min(input.memberCount, 500) * 0.5;
  return Math.round(joinsScore + activityScore + wauScore + memberScore);
}

export function calculateAffiliateCommission(amountCents: number, commissionBps: number): number {
  if (amountCents <= 0 || commissionBps <= 0) return 0;
  return Math.round((amountCents * commissionBps) / 10_000);
}

export function buildCommunityReferralPath(slug: string, referralCode: string): string {
  return `/circles/${slug}?ref=${encodeURIComponent(referralCode)}`;
}
